import styled from 'styled-components'

export const Stamp = styled.div`
    color: #fff;
    width: 120px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 11px;
    font-size: 12px;
    font-weight: 500;
    background-color: #f53d57;
`
